import {useEffect} from "react";
import {observer} from "mobx-react";
import {useStores} from "../hooks";
import useAlias from "../hooks/useAlias";
import {MenuType} from "../services/menu/models";
import MenuView from "./menu/MenuView";
import useQuery from "../hooks/useQuery";
import {useHistory, useParams} from "react-router-dom";
import {useLocation} from "react-router-dom";
import {MenuMode} from "../store/general";
import Catalog from "./catalog";
import RestifyLoader from "./restifyLoader";


const MenuTypeWrapper = () => {

    const { generalMenuStore, menuStore, generalStore, catalogStore} = useStores();
    const history = useHistory();


    const params = useQuery<{
        menuId: string,
        orgId: string,
        branchId: string
    }>();

    const aliasParams = useParams<{
        alias: string
    }>()


    const [alias, isAliasReady] = useAlias();
    const location = useLocation();
    const aliasString = location.pathname !== '/' ? location.pathname.split('/')[1] : null;

    useEffect(() => {
        if(generalMenuStore.type !== MenuType.none) return;

        if(!params.menuId || !params.orgId || !params.branchId) return;
        // Само меню грузит MenuView (он же кладёт его в generalMenuStore); здесь только тип,
        // от которого зависит, какой экран рендерить.
        generalMenuStore.getMenuTypeByMenuId(parseInt(params.menuId));

    }, [generalMenuStore.type, aliasParams.alias, catalogStore.isReady]);

    useEffect(() => {
        if(generalMenuStore.type !== MenuType.none) return;

        (async () => {
            if (alias && isAliasReady && alias.data.aliasedMenus.length === 1) {
                await generalMenuStore.getMenuByAlias(alias.alias, alias.data.aliasedMenus[0].menuId)
                    .then(() => {
                        generalMenuStore.setMenuType(MenuType.regular);
                        generalMenuStore.setMenu(generalMenuStore.menu)
                    })
            } else if (alias && isAliasReady && alias.data.aliasedMenus.length > 1) {

                if (aliasString ) {
                    history.push(`/catalog/${alias.alias}${window.location.search}`)
                }
            }
        })();
    }, [alias, isAliasReady, generalMenuStore, menuStore, generalStore]);

    useEffect(() => {
        if (window.location.pathname === '/') {
            history.replace(`/menu${window.location.search}`)
        }
    }, [window.location.pathname]);

    return <>
        <RestifyLoader
            show={!generalMenuStore.menu && generalStore.modeData.mode !== MenuMode.catalog}
        />
        {generalMenuStore.type === MenuType.regular &&
			<MenuView/>
        }
        {!generalMenuStore.type && generalStore.modeData.mode === MenuMode.catalog &&
            <Catalog/>
        }
    </>
}

export default observer(MenuTypeWrapper)
